import { Dialog, AppBar, Toolbar, IconButton, Typography, Button } from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import RetractionsForOpenAlexAuthor from "./RetractionsForOpenAlexAuthor";

interface RetractionsForOpenAlexAuthorDialogProps {
    openAlexAuthorId: string,
    institutionId: string | undefined,
    institutionName: string | undefined,
    collaborationMode: boolean,
    authorDisplayName: string,
    openDrilldown: boolean,
    handleClose: () => void
}

function RetractionsForOpenAlexAuthorDialog({ openAlexAuthorId, authorDisplayName, institutionId, institutionName, collaborationMode, openDrilldown, handleClose }: RetractionsForOpenAlexAuthorDialogProps) {

    return <Dialog
        fullScreen
        open={openDrilldown}
        onClose={handleClose}
    >
        <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
                <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                    Retractions for {authorDisplayName} {
                        institutionId !== undefined && <>
                            {collaborationMode && <>in collaboration with authors from {institutionName}</>}
                            {!collaborationMode && <>with affiliation reported as {institutionName}</>}
                        </>
                    }
                </Typography>
                <Button autoFocus color="inherit" onClick={handleClose}>
                    Close
                </Button>
            </Toolbar>
        </AppBar>
        <RetractionsForOpenAlexAuthor authorProfileId={openAlexAuthorId} authorDisplayName={authorDisplayName} institutionId={institutionId} collaborationMode={collaborationMode}/>
    </Dialog>
}

export default RetractionsForOpenAlexAuthorDialog;